<main class="main">
  <div class="card mt-4 bg-neutral text-neutral-content inset-x-0 max-w-max mx-auto font-montserrat">
    <div class="card-body mx-8 flex items-center justify-center flex-col">
      <h2 class="font-light text-xl md:text-2xl termina-regular">Email Verification</h2>
      <app-logo class="w-[100px] my-4"></app-logo>
      <div class="text-lg">
        Before you proceed, please verify your email address by entering the code we have sent to your email inbox.
      </div>

      <div class="text-lg mt-4">
        <input [(ngModel)]="emailVerificationCode" class="input font-montserrat" placeholder="Code" />
      </div>
    </div>
  </div>
  <div class="flex justify-center gap-4">

  <button [disabled]="resendButtonDisabled" (click)="sendVerificationEmail(true)" class="mt-2 btn btn-neutral" matRipple type="button">
      Resend Email
    </button>
    <button (click)="continue()" class="mt-2 btn btn-neutral" matRipple type="button">
      Done
    </button>
  </div>
</main>